import _get from 'lodash/get';
import { generateInitialsAvatar, executeAttachment } from '@utils';
import { store } from '../store';
import { ImageShape } from '@enums';
import { AttachmentEntityInterface, UserEntityInterface } from '@types';
import { generateTextImage } from './generateTextImage';

export const executeImage = (
  name: string,
  isDownload = false,
  stub = true,
  owner: UserEntityInterface | null,
  shape?: ImageShape,
  isCalendar = false
) => {
  let attachments: AttachmentEntityInterface[] = [];

  if (store) {
    const submissionState = store.getState()?.submissionEnvironment;
    const answerState = store.getState()?.answerEnvironment;
    attachments = [...submissionState.attachments, ...answerState.attachments];
  }

  const image = executeAttachment(attachments, name);
  const data = _get(image, 'data.data');
  const base64Data = ['string', 'undefined'].includes(typeof data) ? data : data[shape];

  if (!isDownload) {
    if (stub) {
      return base64Data
        ? `data:image/png;base64,${base64Data}`
        : owner?.id
        ? generateInitialsAvatar(owner?.fullNameEng, shape)
        : generateTextImage('NO IMAGE\nAVAILABLE', shape);
    } else {
      return base64Data ? `data:image/png;base64,${base64Data}` : null;
    }
  }

  if (isCalendar) {
    if (owner) {
      return _get(image, 'data.name')
        ? `data:image/png;base64,${data[ImageShape.SQUARE]}`
        : undefined;
    }
    return _get(image, 'data.imageURL') ? `${_get(image, 'data.imageURL')}` : undefined;
  }

  return _get(image, 'data.name') ? `cid:${_get(image, 'data.name')}` : undefined;
};

export const executeImageFactory =
  (isCalendar: boolean) =>
  (
    name: string,
    isDownload = false,
    stub = true,
    owner: UserEntityInterface | null,
    shape?: ImageShape
  ) => {
    return executeImage(name, isDownload, stub, owner, shape, isCalendar);
  };
